import { useQuery } from 'react-query';

import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';

import { IGanttChartPayload, IGanttChartResponse } from 'components/widgets/Gantt/components/ganttChart.types';

export const useQueryGanttChart = (params: IGanttChartPayload | null, endpoint?: string) => {
    return useQuery<IGanttChartResponse, QueryError>(
        ['ganttChartActivities', params],
        () => queryFn(params, endpoint),
        {
            enabled:
                Boolean(params?.id) && typeof params?.maxLevel === 'number' && typeof params?.minLevel === 'number',
            placeholderData: {
                activities: [],
                info: {
                    infoList: '',
                    link: '',
                },
                versionDate: 0,
            },
        },
    );
};
